import { Ring, Sphere } from '@react-three/drei';
import React, { useRef } from 'react';
import * as THREE from 'three';
import RENDER_ORDERS from '../../utils/renderOrder';

interface PreviewHotspotProps {
  position: THREE.Vector3;
}

const PreviewHotspot: React.FC<PreviewHotspotProps> = ({ position }) => {
  const outlineRef = useRef<THREE.Mesh>(null!);

  return (
    <group
      position={[position.x, position.y, 5]}
      renderOrder={RENDER_ORDERS.hotspot}
    >
      {/* inner sphere, more transparent */}
      <mesh position={[0, 0, 1]}>
        <Sphere args={[0.8, 50, 50]}>
          <meshBasicMaterial
            color="#009fe3"
            transparent
            opacity={0.25}
            side={THREE.DoubleSide}
          />
        </Sphere>
      </mesh>

      {/* outer ring, more transparent */}
      <mesh ref={outlineRef}>
        <Ring args={[0.8, 0.9, 52]}>
          <meshBasicMaterial
            color="#009fe3"
            transparent
            opacity={0.25}
            side={THREE.DoubleSide}
          />
        </Ring>
      </mesh>
    </group>
  );
};

export default PreviewHotspot;
